<template>
    <div class="input-group">
        <slot/>
    </div>
</template>